import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import customDataRoutes from '@/router/modules/custom-data'
import NetworkNoticeRoutes from '@/router/modules/network-notice'
import subscriptionRoutes from '@/router/modules/subscription'
import competitorAnalysisRoutes from '@/router/modules/competitor-analysis'
import purchaserAnalysisRoutes from '@/router/modules/purchaser-analysis'
import focusRoutes from '@/router/modules/follow'
import noticeRoutes from '@/router/modules/notice'
import ServiceIntroductionRoutes from '@/router/modules/service-introduction'
import vipRoutes from '@/router/modules/vip'
import aiCheckRoutes from '@/router/modules/ai-check'
import aiBidRoutes from '@/router/modules/ai-bid.js'

Vue.use(VueRouter)

/**
 * meta特殊参数说明：
 * - layout: 当前页面需要使用的布局容器
 * - title: 当前页的标题
 * - inNavbar: 是否在导航栏里显示
 * - public: 是否可以公开访问，即未登录状态下也允许进入页面，目前仅一级导航菜单页面允许访问
 * - pageType: private/public/protected   默认为private（仅登录后可展示），public（任何时候都可展示），protected（仅登录前可展示），目前仅一级导航菜单页面允许访问
 * - TODO: pageType的protected控制逻辑暂未实现
 * - cache: boolean 设置路由对应页面是否需要被缓存（默认不缓存）
 * - firstRouteName：string 当前路由为二级菜单，设置一级导航名称
 */

const defaultRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { layout: 'HomeLayout', title: '首页', pageType: 'public' }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/404'),
    meta: { layout: 'DefaultLayout', pageType: 'public' }
  },
  ...ServiceIntroductionRoutes,
  ...aiCheckRoutes,
  ...NetworkNoticeRoutes,
  ...subscriptionRoutes,
  ...competitorAnalysisRoutes,
  ...purchaserAnalysisRoutes,
  ...customDataRoutes,
  ...focusRoutes,
  ...noticeRoutes,
  ...vipRoutes,
  aiBidRoutes,
  { path: '*', redirect: '/404', hidden: true, pageType: 'public' }
]

/**
 * 对定义的路由结构进行处理
 * 对于父路由没有component属性的，对该路由进行拍平处理
 */
function handleRouterList(routerList) {
  // 对路由进行解析
  const loop = (list, parent = {}) => {
    return list.map((router) => {
      // 因为拍平路由，需要将父路由上的路径与子路由合并
      const parentPath = parent.path || ''
      const layout = parent?.meta?.layout
      if (parentPath && !router.path.startsWith(parentPath)) {
        router.path = `${parentPath}/${router.path}`
        router.path = router.path.replace(/\/+/g, '/')
      }
      // 子路由默认继承父路由的layout
      if (router.meta && layout) {
        router.meta.layout = router.meta.layout || layout
      }
      // 记录父子路由关系，目前使用场景为面包屑
      if (!router.meta) router.meta = {}
      router.meta.breadcrumb = [
        ...(parent?.meta?.breadcrumb || []),
        { title: router?.meta?.title, name: router.name }
      ]

      if (router.children && (router.component || router?.meta?.keepParent)) {
        router.children = loop(router.children, router)
        return router
      } else if (router.children) {
        return loop(router.children, router)
      } else {
        return router
      }
    })
  }

  // 对路由解析过程中产生的多维数组进行拍平处理
  const routerListTemp = []
  const parseArrayLoop = (list) => {
    list.forEach((value) => {
      if (Array.isArray(value)) {
        parseArrayLoop(value)
      } else {
        routerListTemp.push(value)
      }
    })
  }

  parseArrayLoop(loop(routerList))
  return routerListTemp
}

export const routes = handleRouterList(defaultRoutes)

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes
})

export const useRouter = () => router

export const useRoute = () => router.currentRoute

export default router
